import { useState } from "react";
import {
  getGarageCoverImage,
  getGaragePhaseName,
  getGarageVehicleTitle
} from "../utils/vehicleDisplay";

function GarageVehicleCard({ car, username, navigate, onSelectPhase, onManage }) {
  const [imageFailed, setImageFailed] = useState(false);
  const vehicleTitle = getGarageVehicleTitle(car);
  const phaseName = getGaragePhaseName(car);
  const coverImage = getGarageCoverImage(car);
  const status = String(car.status || car.buildStatus || "").trim();
  const buildRoute = `/user/${(username || "").toLowerCase()}/car/${car.id}`;

  return (
    <article style={cardStyle}>
      <div style={coverStyle}>
        {coverImage && !imageFailed ? (
          <img src={coverImage} alt={`${vehicleTitle} cover`} style={coverImageStyle} onError={() => setImageFailed(true)} />
        ) : (
          <div style={placeholderStyle} role="img" aria-label={`${vehicleTitle} has no cover photo`}>
            <span aria-hidden="true" style={placeholderIconStyle}>▱</span>
            <span>No photo yet</span>
          </div>
        )}
      </div>

      <div style={contentStyle}>
        <div style={titleRowStyle}>
          <button type="button" onClick={() => navigate(buildRoute)} style={titleButtonStyle} title={vehicleTitle}>
            {vehicleTitle}
          </button>
          {status && <span style={statusPillStyle}>{status.toUpperCase()}</span>}
        </div>

        <button
          type="button"
          onClick={onSelectPhase}
          style={phaseButtonStyle}
          aria-label={`Change build phase. Current phase: ${phaseName}`}
          title={phaseName}
        >
          <span style={phaseLabelStyle}>Build Phase:</span>
          <span style={phaseValueStyle}>{phaseName}</span>
          <span aria-hidden="true" style={phaseArrowStyle}>▼</span>
        </button>

        <div style={actionRowStyle}>
          <button type="button" onClick={() => navigate(buildRoute)} style={openButtonStyle}>Open Build</button>
          <button type="button" onClick={onManage} style={manageButtonStyle}>Manage Vehicle</button>
        </div>
      </div>
    </article>
  );
}

const cardStyle = { width: "100%", maxWidth: "100%", overflow: "hidden", border: "1px solid #303030", borderRadius: "18px", background: "#1b1b1b", boxShadow: "0 14px 34px rgba(0,0,0,.2)", boxSizing: "border-box" };
const coverStyle = { width: "100%", aspectRatio: "16 / 9", overflow: "hidden", background: "#101010" };
const coverImageStyle = { display: "block", width: "100%", height: "100%", objectFit: "cover" };
const placeholderStyle = { display: "flex", width: "100%", height: "100%", alignItems: "center", justifyContent: "center", flexDirection: "column", gap: "8px", color: "#777", fontSize: "12px", fontWeight: "700" };
const placeholderIconStyle = { color: "#e10600", fontSize: "34px", lineHeight: 1 };
const contentStyle = { display: "grid", gap: "16px", minWidth: 0, padding: "16px" };
const titleRowStyle = { display: "flex", minWidth: 0, alignItems: "flex-start", justifyContent: "space-between", gap: "10px" };
const titleButtonStyle = { display: "-webkit-box", minWidth: 0, overflow: "hidden", padding: 0, border: 0, background: "transparent", color: "#fff", cursor: "pointer", fontSize: "clamp(19px,5.5vw,24px)", fontWeight: "800", lineHeight: 1.18, textAlign: "left", textOverflow: "ellipsis", WebkitBoxOrient: "vertical", WebkitLineClamp: 2 };
const statusPillStyle = { flex: "0 0 auto", maxWidth: "42%", overflow: "hidden", padding: "6px 8px", border: "1px solid #454545", borderRadius: "999px", color: "#bbb", fontSize: "9px", fontWeight: "900", letterSpacing: ".8px", textOverflow: "ellipsis", whiteSpace: "nowrap" };
const phaseButtonStyle = { display: "flex", width: "100%", maxWidth: "100%", minWidth: 0, minHeight: "48px", alignItems: "center", gap: "6px", padding: "10px 13px", border: "1px solid #3a3a3a", borderRadius: "12px", background: "#252525", color: "#fff", cursor: "pointer", fontSize: "12px", boxSizing: "border-box" };
const phaseLabelStyle = { flex: "0 0 auto", color: "rgba(255,255,255,.62)", fontWeight: "600", whiteSpace: "nowrap" };
const phaseValueStyle = { minWidth: 0, overflow: "hidden", fontWeight: "900", textOverflow: "ellipsis", whiteSpace: "nowrap" };
const phaseArrowStyle = { flex: "0 0 auto", marginLeft: "auto", fontSize: "9px" };
const actionRowStyle = { display: "flex", flexWrap: "wrap", gap: "9px" };
const actionButtonStyle = { minWidth: "130px", minHeight: "46px", flex: "1 1 140px", borderRadius: "11px", padding: "10px 13px", color: "#fff", cursor: "pointer", fontSize: "14px", fontWeight: "900" };
const openButtonStyle = { ...actionButtonStyle, border: "1px solid #e10600", background: "#e10600" };
const manageButtonStyle = { ...actionButtonStyle, border: "1px solid #404040", background: "#2a2a2a" };

export default GarageVehicleCard;
